import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { noop } from 'lodash';
import { useEffect, useState } from 'react';
import { json2mq } from '../media-queries'; // For SSR

var __window = {};

if (typeof window !== 'undefined') {
  __window = window;
}

function mockMatchMedia() {
  return {
    addListener: noop,
    removeListener: noop
  };
}
/**
 * Checks to see if the media query matches the current viewport.
 *
 * Source:
 * https://github.com/jaredpalmer/the-platform
 *
 * @param {string | Object} query
 * @param {boolean} defaultMatches
 *
 * @return {boolean} Whether the query matches the current viewport.
 */


export function useMediaQuery(query, defaultMatches) {
  if (defaultMatches === void 0) {
    defaultMatches = true;
  }

  var _useState = useState(defaultMatches),
      _useState2 = _slicedToArray(_useState, 2),
      matches = _useState2[0],
      setMatches = _useState2[1];

  var matchMedia = __window.matchMedia || mockMatchMedia;
  useEffect(function () {
    var mediaQueryList = matchMedia(typeof query === 'string' ? query : json2mq(query));
    var active = true;

    var listener = function () {
      if (!active) {
        return;
      }

      if (mediaQueryList.matches) {
        setMatches(true);
      } else {
        setMatches(false);
      }
    };

    mediaQueryList.addListener(listener);
    setMatches(mediaQueryList.matches);
    return function () {
      active = false;
      mediaQueryList.removeListener(listener);
    };
  }, [matchMedia, query]);
  return matches;
}